import React from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Button, Card, Icon } from '@node-space/ui-components'
import type { Limit } from 'types/paymentLimits'
import { formatNumberWithCommas } from 'utils/utils'
import { formatPaymentMethodLabel, LIMIT_TYPE_LABELS } from '../utils'

interface PaymentLimitCardProps {
  limit: Limit
  onEditLimit?: (limit: Limit) => void
}

export const PaymentLimitCard = ({ limit, onEditLimit }: PaymentLimitCardProps) => {
  const { t } = useTranslation()

  return (
    <Card variant="static" emphasis full className="py-6">
      <Box flexCol>
        <h3 className="text-h3 text-foreground-prominent">
          {formatPaymentMethodLabel(limit.qualifiers.method)}
        </h3>

        <Box flex align="center" gap={8} className="mt-1">
          <Avatar name={limit.currency} type="currency" size="small" />
          <Box className="text-body-regular-small text-foreground-subdued">{limit.currency}</Box>
        </Box>

        <Box flex justify="between" align="center" className="pt-8">
          <Box className="text-body-regular-small text-foreground-subdued">
            {t(LIMIT_TYPE_LABELS[limit.limitType] ?? limit.limitType)}
          </Box>
          <Box className="text-body-regular-small text-foreground-prominent">
            {formatNumberWithCommas(limit.amount)}
          </Box>
        </Box>

        <Box flex justify="center" className="pt-8">
          <Button
            variant="ghost"
            noPadding
            onClick={() => onEditLimit?.(limit)}
            iconElement={<Icon name="SimplePencilCustom" />}
          >
            {t('paymentLimits.editLimits')}
          </Button>
        </Box>
      </Box>
    </Card>
  )
}
